import React from 'react';

// Lets a screen adjust a chart's final Highcharts options without touching
// the gadget that built them (e.g. Studio adding forecast series). Charts
// outside a provider are left as they are.
export type ChartOptionsTransform = (
  options: Highcharts.Options,
) => Highcharts.Options;

const ChartOptionsTransformContext = React.createContext<
  ChartOptionsTransform | undefined
>(undefined);

export default ChartOptionsTransformContext;
